import { useNavigate } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';

import {
  InteractionType,
  type PublicClientApplication,
} from '@azure/msal-browser';

import AppRouter from './AppRouter';
import { CustomNavigationClient } from '@/lib/NavigationClient';
import { loginRequest } from '@/config/msalConfig';
import { reactPlugin } from '@/config/telemetry';

interface AppProps {
  msalInstance: PublicClientApplication;
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
});

function App({ msalInstance }: AppProps) {
  const navigate = useNavigate();
  const navigationClient = new CustomNavigationClient(navigate);
  msalInstance.setNavigationClient(navigationClient);

  return (
    <AppInsightsContext.Provider value={reactPlugin}>
      <MsalProvider instance={msalInstance}>
        <QueryClientProvider client={queryClient}>
          <MsalAuthenticationTemplate
            interactionType={InteractionType.Redirect}
            authenticationRequest={loginRequest}
          >
            <AppRouter />
          </MsalAuthenticationTemplate>
        </QueryClientProvider>
      </MsalProvider>
    </AppInsightsContext.Provider>
  );
}

export default App;
